import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {ContractModel} from '../_models/contract.model';
import {ViewManagementModel} from '../../top-management/_models/viewManagement.model';
import base64 from 'base-64';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})

export class ContractsDataService {
    constructor(private http: HttpClient) {
    }

    username = 'georgiana@thecon.ro';
    password = '002|115e987b7b3143d3cf2c1492c61490e7';


    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type':  'application/json',
            'Accept': 'application/json',
            'authorization': 'Basic ' + base64.encode(this.username + ":" +  this.password)

        })
    };

    payHttpOptions = {
        headers: new HttpHeaders({
            'Content-Type':  'application/xml',
            'Accept': 'application/xml',
            'authorization': 'Basic ' + base64.encode(this.username + ":" +  this.password)

        })
    };


    getHttpOptions = {
        headers: new HttpHeaders({
            'Content-Type':  'application/xml',
            'Accept': 'application/xml, application/octet-stream',
            'authorization': 'Basic ' + base64.encode(this.username + ":" +  this.password),
            'Content-Disposition': 'attachment'
        })
    }

    // Get All Company
    getAllCompany() {
        return this.http.get('agri/crm/getAllCompanies');
    }

    // Create Contract
    createContract(contractData: object) {
        return this.http.post('agri/crm/createContract', contractData);
    }

    // View Contract
    viewContract(contractId: string) {
        return this.http.get<ContractModel>('agri/crm/viewContract?contractId=' + contractId);
    }

    // All Contracts
    getAllContracts() {
        return this.http.get<ContractModel[]>('agri/crm/allContracts');
    }

    // Update Contract
    editContract(contractId: string, updatedData: object) {
        return this.http.put('agri/crm/updateContract?contractId=' + contractId, updatedData)
    }

    // Filter Contracts
    listContractFilter(size, page, sort, orderDir, filterData: object) {
        return this.http.post<ContractModel>('agri/listContractFiltered?page=' + (page - 1) + '&size=' + size + '&sort=' + sort + '&dir=' + orderDir, filterData);
    }

    updateBillNumber(contractId, seriesName, seriesNumber) {
        return this.http.put('agri/crm/updateBillNumber?contractId=' + contractId + '&seriesName=' + seriesName + '&seriesNumber=' + seriesNumber, {});
    }

    createBill(client, products) {
        return this.http.post('https://ws.smartbill.ro/SBORO/api/invoice', {
            companyVatCode: "RO13659420", client, products},
            this.httpOptions)
    }

    downloadFile(cif, seriesName, seriesNumber): any {
        return this.http.get('https://ws.smartbill.ro/SBORO/api/invoice/pdf?cif=' + cif + '&seriesname=' + seriesName + '&number=' + seriesNumber,
            {headers: this.getHttpOptions.headers,
                    responseType: 'blob'});
    }

    payBill(paymentObject: object) {
        return this.http.post('https://ws.smartbill.ro/SBORO/api/payment', paymentObject, this.httpOptions);
    }

    getPaymentStatus(cif, seriesName, seriesNumber){
        return this.http.get('https://ws.smartbill.ro/SBORO/api/invoice/paymentstatus?cif=' + cif + '&seriesname=' + seriesName + '&number=' + seriesNumber, this.httpOptions);
    }
}
